import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { LinkRollfiUser } from 'domain/usecases';

import { RemoteLinkRollfiUser } from 'data/usecases/rollfi';

export const makeLinkRollfiUser = (): LinkRollfiUser => {
  return new RemoteLinkRollfiUser(makeApiUrl('/rollfi/user/link'), makeAuthorizeHttpClientDecorator());
};
